var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"update-module"}},[(_vm.module)?_c('module-form',{attrs:{"is-create":false,"moduleInfo":_vm.moduleInfo,"submit":_vm.changeModule}}):_c('a-result',{attrs:{"status":"warning","title":"The module is not editable"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }